<template>
  <div
    class="overview-product-card tw-flex tw-flex-col tw-items-center tw-bg-white lg:tw-px-6 lg:tw-py-10 tw-px-5 tw-py-8 tw-rounded-xl"
  >
    <!-- Image Section -->
    <div v-if="image" class="tw-w-full tw-flex tw-justify-center tw-mb-6">
      <MediaImageLazyLoad
        :src="image"
        :alt="title"
        width="100px"
        height="100px"
        custom-class="overview-product-image"
        seo-optimize
      />
    </div>

    <!-- Content Section -->
    <div class="tw-text-center">
      <h3
        class="tw-text-mb-title-5 lg:tw-text-dt-title-4 tw-text-black tw-mb-2 lg:tw-mb-1"
      >
        {{ title }}
      </h3>
      <p class="tw-text-dt-body-small lg:tw-text-dt-body tw-text-dark-gray">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  image: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
});
</script>

<style scoped>
.overview-product-card {
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
}
</style>
